module.exports = __webpack_public_path__ + "img/logo-believe-loans.fbe22a94.svg";